import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Divider, Tag } from 'antd';
import { EyeInvisibleFilled } from '@ant-design/icons';
import { getColorStatus } from 'utils/funcaoPadrao';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { MSG_HISTORICO_NAO_ENCONTRADO } from 'utils/consts';
import * as S from './styles';
import { valueOrDefaultValue } from 'utils/formUtils';

export const Historico = ({ dadosExibir }) => {
  const montarArrayJustificativa = historicoRow => {
    const observacao = historicoRow?.observacao;
    if (observacao && observacao[0] === '<') {
      return (
        <div style={{ marginLeft: '10px' }}>
          <p>{historicoRow?.responsavel}:</p>

          <td
            dangerouslySetInnerHTML={{
              __html: observacao.replace('<p>', "<p class='observacao'>"),
            }}
          />
        </div>
      );
    } else {
      return (
        <Col>
          {/* CONTRIBUINTE */}
          {historicoRow?.atribuicao === 'CONTRIBUINTE' && observacao && (
            <p style={{ marginLeft: '10px' }}>Contribuinte: {observacao}</p>
          )}
          {historicoRow?.atribuicao === 'CONTRIBUINTE' && !observacao && <p style={{ marginLeft: '10px' }}>-</p>}

          {/* NÃO CONTRIBUINTE */}
          {historicoRow?.atribuicao !== 'CONTRIBUINTE' && historicoRow?.responsavel && (
            <p style={{ marginLeft: '10px' }}>
              {historicoRow?.responsavel}: {observacao}
            </p>
          )}
          {historicoRow?.atribuicao !== 'CONTRIBUINTE' && !historicoRow?.responsavel && (
            <p style={{ marginLeft: '10px' }}>{observacao}</p>
          )}
        </Col>
      );
    }
  };

  const renderRow = historicoRow => {
    return (
      <div key={historicoRow?.id}>
        <Row justify={'flex-start'}>
          <S.HistoricoRow>
            <S.HistoricoLabel>
              <Tag {...getColorStatus(historicoRow?.status?.id)}>{historicoRow?.status?.descricao?.toUpperCase()}</Tag>
            </S.HistoricoLabel>
          </S.HistoricoRow>
          <S.HistoricoRow>
            <S.HistoricoLabel>Tempo decorrido:</S.HistoricoLabel>
            <p>{historicoRow?.tempoDecorrido}</p>
          </S.HistoricoRow>
        </Row>
        <Row justify={'space-between'}>
          <S.HistoricoRow>
            <S.HistoricoLabel>Data/Hora:</S.HistoricoLabel>
            <p>{convertDatePtBrHs(historicoRow?.dataMudancaStatus)}</p>
          </S.HistoricoRow>

          <S.HistoricoRow>
            <S.HistoricoLabel>Responsável:</S.HistoricoLabel>
            <p>{historicoRow?.responsavel}</p>
          </S.HistoricoRow>

          <S.HistoricoRow>
            <S.HistoricoLabel>Atribuição:</S.HistoricoLabel>
            <p>{historicoRow?.atribuicao}</p>
          </S.HistoricoRow>
        </Row>
        <S.HistoricoRow>
          <S.HistoricoLabel>De setor:</S.HistoricoLabel>
          <p>{valueOrDefaultValue(historicoRow?.setorOrigem?.nome, ' -- ')}</p>
          <S.HistoricoLabel> Para setor:</S.HistoricoLabel>
          <p>{valueOrDefaultValue(historicoRow?.setorDestino?.nome, ' -- ')} </p>
          <span style={{ marginLeft: '4px' }}>
            - <b>Atendente{historicoRow?.atendente?.isSetorial ? ' Setorial' : ''}</b>:{' '}
            {historicoRow?.atendente?.apelido}{' '}
          </span>
        </S.HistoricoRow>
        <S.HistoricoRow style={{ display: 'block' }}>
          <S.HistoricoLabel>Observação:</S.HistoricoLabel>
          {montarArrayJustificativa(historicoRow)}
        </S.HistoricoRow>
        <Divider />
      </div>
    );
  };

  const renderEmpty = () => {
    return (
      <div key={'renderEmpty'}>
        <Row justify={'center'}>
          <S.HistoricoRowEmpty>
            <EyeInvisibleFilled /> {MSG_HISTORICO_NAO_ENCONTRADO}
          </S.HistoricoRowEmpty>
        </Row>
      </div>
    );
  };

  return (
    <S.HistoricoContainer>
      {dadosExibir && dadosExibir?.length === 0 ? (
        renderEmpty()
      ) : (
        <>
          <Row justify="end">
            <S.HistoricoLabel>Protocolo: </S.HistoricoLabel>
            <S.HistoricoDestaque>{dadosExibir[0]?.formulario?.localizador}</S.HistoricoDestaque>
          </Row>
          {dadosExibir.map(historicoRow => {
            return renderRow(historicoRow);
          })}
        </>
      )}
    </S.HistoricoContainer>
  );
};

Historico.propTypes = {
  dadosExibir: PropTypes.array,
};

export default Historico;
